import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Basic Single Story",
    description:
        "Bare minimum: 1 story, must have a dek if there are no relateds. A liveblog needs no dek.",
    links: [
        {
            name: "Editorial Team Guide",
            url: "https://docs.google.com/document/d/1XVAaeEBxk8ifuhKiUqNn_jvpwPbTet681IRnLv4MLRQ/edit?tab=t.0#heading=h.ovu5c8cr2ix1",
        },
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.bn83wuavki35",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/gMELOCd5MiIqECTbVITX8y/Homepage?node-id=1382-5973&m=dev",
        },
    ],
};
